export const invoicesEn: Record<string, string> = {
  'invoices.totalInvoiced': 'Total Invoiced',
  'invoices.totalPaid': 'Total Paid',
  'invoices.outstanding': 'Outstanding',
  'invoices.availableToInvoice': 'Available to Invoice',
  'invoices.mainInvoice': 'Main Invoice',
  'invoices.invoiceNumber': 'Invoice #',
  'invoices.issueDate': 'Issue Date',
  'invoices.dueDate': 'Due Date',
  'invoices.totalAmount': 'Total Amount',
  'invoices.amountPaid': 'Amount Paid',
  'invoices.print': 'Print',
  'invoices.recordPayment': 'Record Payment',
  'invoices.paymentRequests': 'Payment Requests',
  'invoices.printInvoice': 'Print Invoice',
  'invoices.printPaymentRequest': 'Print Payment Request',
  'invoices.printReceipt': 'Print Receipt',
  'invoices.amount': 'Amount',
  'invoices.description': 'Description',
  'invoices.allPayments': 'All Payments',
  'invoices.paymentMethod': 'Payment Method',
  'invoices.date': 'Date',
  'invoices.receiptNumber': 'Receipt #',
  'invoices.createInvoice': 'Create Invoice',
  'invoices.createPaymentRequest': 'Create Payment Request',
  'invoices.archive': 'Archive',
  'invoices.remaining': 'Remaining',
  'invoices.paymentRequestCreated': 'Payment Request Created',
  'invoices.paymentRequestCreatedDescription': 'Payment request has been created successfully',
  'invoices.invoiceCreated': 'Invoice Created',
  'invoices.invoiceCreatedDescription': 'Invoice {number} has been created successfully',
  'invoices.paymentAdded': 'Payment Added',
  'invoices.paymentAddedDescription': 'Payment has been recorded successfully',
  'invoices.refundRecorded': 'Refund Recorded',
  'invoices.refundRecordedDescription': 'Refund has been recorded successfully',
  'invoices.invoicePrinted': 'Invoice Printed',
  'invoices.invoicePrintedDescription': 'Invoice opened for printing',
  'invoices.paymentRequestOpened': 'Payment Request Opened',
  'invoices.paymentRequestOpenedDescription': 'Payment request opened for printing',
  'invoices.paymentRequestArchived': 'Payment Request Archived',
  'invoices.paymentRequestArchivedDescription': 'Payment request has been archived successfully',
  'invoices.receiptOpened': 'Receipt Opened',
  'invoices.receiptOpenedDescription': 'Payment receipt opened in new tab',
  'invoices.errorLoadingData': 'Failed to load invoices and payment data',
  'invoices.errorCreatingInvoice': 'Failed to create invoice',
  'invoices.errorCreatingPaymentRequest': 'Failed to create payment request',
  'invoices.errorRecordingPayment': 'Failed to record payment',
  'invoices.errorPrintingInvoice': 'Failed to print invoice',
  'invoices.errorPrintingPaymentRequest': 'Failed to print payment request',
  'invoices.errorArchivingPaymentRequest': 'Failed to archive payment request',
  'invoices.errorOpeningReceipt': 'Failed to open payment receipt',
  'invoices.noInvoiceFound': 'No invoice found to create payment request against',
  'invoices.mustBeLoggedIn': 'You must be logged in to record payments',
  'invoices.noInvoiceYet': 'No invoice yet',
  'invoices.createMainInvoice': 'Create Main Invoice',
  'invoices.noPaymentRequestsYet': 'No payment requests yet',
  'invoices.noPaymentsYet': 'No payments recorded yet',
  'invoices.fullyPaid': 'Fully Paid',
  'invoices.overpaid': 'Overpaid',
  'invoices.archivePaymentRequest': 'Archive Payment Request',
  'invoices.archivePaymentRequestConfirm': 'Are you sure you want to archive this payment request? This action cannot be undone.',
  'invoices.editOrder': 'Edit Order',
  'invoices.orderUpdated': 'Order updated successfully',
  'invoices.errorUpdatingOrder': 'Failed to update order',
  'invoices.discountType': 'Discount Type',
  'invoices.percentage': 'Percentage',
  'invoices.fixedAmount': 'Fixed Amount',
  'invoices.notesPlaceholder': 'Internal notes about this order...',
  'invoices.standalone.title': 'Create Invoice - Step {step} of 3',
  'invoices.standalone.step1Description': 'Select an order to invoice',
  'invoices.standalone.step2Description': 'Set the invoice amount and dates',
  'invoices.standalone.step3Description': 'Review and confirm invoice details',
  'invoices.standalone.searchPlaceholder': 'Search orders by number or customer name...',
  'invoices.standalone.selectOrder': 'Select Order',
  'invoices.standalone.loadingOrders': 'Loading orders...',
  'invoices.standalone.noOrdersMatchingSearch': 'No orders found matching your search',
  'invoices.standalone.noOrdersAvailable': 'No orders available for invoicing',
  'invoices.standalone.ofTotalRemaining': 'of EUR {total} remaining',
  'invoices.standalone.selectedOrder': 'Selected Order',
  'invoices.standalone.orderLabel': 'Order:',
  'invoices.standalone.customerLabel': 'Customer:',
  'invoices.standalone.availableToInvoiceLabel': 'Available to invoice:',
  'invoices.standalone.invoiceAmount': 'Invoice Amount',
  'invoices.standalone.amountPlaceholder': '0.00',
  'invoices.standalone.amountExceedsBalance': 'Amount exceeds available balance',
  'invoices.standalone.quickAmounts': 'Quick Amounts',
  'invoices.standalone.fullBalance': 'Full Balance: EUR {amount}',
  'invoices.standalone.halfBalance': 'Half: EUR {amount}',
  'invoices.standalone.pickDate': 'Pick a date',
  'invoices.standalone.invoiceSummary': 'Invoice Summary',
  'invoices.standalone.invoiceAmountLabel': 'Invoice Amount:',
  'invoices.standalone.notSet': 'Not set',
  'invoices.standalone.remainingAfterInvoice': 'Remaining after this invoice:',
  'invoices.standalone.draftNotice': 'The invoice will be created as a draft. You can then print it or mark it as issued when ready.',
  'invoices.standalone.back': 'Back',
  'invoices.standalone.next': 'Next',
  'invoices.standalone.fetchOrdersError': 'Failed to fetch orders',
  'invoices.standalone.userOrgNotFound': 'User organization not found',
  'invoices.standalone.invoiceCreatedSuccess': 'Invoice created successfully',
  'invoices.createDialog.title': 'Create Invoice - Step {step} of 2',
  'invoices.createDialog.step1Description': 'Set the invoice amount and dates',
  'invoices.createDialog.step2Description': 'Review and confirm invoice details',
  'invoices.createDialog.invoiceAmount': 'Invoice Amount',
  'invoices.createDialog.amountPlaceholder': '0.00',
  'invoices.createDialog.availableToInvoice': 'Available to invoice: EUR {amount}',
  'invoices.createDialog.amountExceedsBalance': 'Amount exceeds available balance',
  'invoices.createDialog.quickAmounts': 'Quick Amounts',
  'invoices.createDialog.suggestedAmount': 'Suggested: EUR {amount}',
  'invoices.createDialog.fullBalance': 'Full Balance: EUR {amount}',
  'invoices.createDialog.halfBalance': 'Half: EUR {amount}',
  'invoices.createDialog.issueDate': 'Issue Date',
  'invoices.createDialog.dueDate': 'Due Date',
  'invoices.createDialog.pickDate': 'Pick a date',
  'invoices.createDialog.invoiceSummary': 'Invoice Summary',
  'invoices.createDialog.invoiceAmountLabel': 'Invoice Amount:',
  'invoices.createDialog.issueDateLabel': 'Issue Date:',
  'invoices.createDialog.dueDateLabel': 'Due Date:',
  'invoices.createDialog.notSet': 'Not set',
  'invoices.createDialog.remainingAfterInvoice': 'Remaining after this invoice:',
  'invoices.createDialog.issuedNotice': 'Once created, this invoice will be marked as "Issued" and can be downloaded as a PDF. You can then record payments against this invoice as they are received.',
  'invoices.createDialog.back': 'Back',
  'invoices.createDialog.cancel': 'Cancel',
  'invoices.createDialog.next': 'Next',
  'invoices.createDialog.createInvoice': 'Create Invoice',
  'invoices.printTemplate.logoPlaceholder': 'LOGO',
  'invoices.printTemplate.telLabel': 'Tel.',
  'invoices.printTemplate.faxLabel': 'Fax',
  'invoices.printTemplate.vatLabel': 'VAT',
  'invoices.printTemplate.taxCodeLabel': 'Tax Code',
  'invoices.printTemplate.documentTitle': 'SALES CONTRACT / INVOICE',
  'invoices.printTemplate.invoiceDate': 'Invoice Date',
  'invoices.printTemplate.invoiceNumber': 'Invoice Number',
  'invoices.printTemplate.customer': 'Customer',
  'invoices.printTemplate.address': 'Address',
  'invoices.printTemplate.taxCode': 'Tax Code',
  'invoices.printTemplate.phone': 'Phone',
  'invoices.printTemplate.firstFitting': 'First Fitting',
  'invoices.printTemplate.secondFitting': 'Second Fitting',
  'invoices.printTemplate.deliveryDate': 'Delivery Date',
  'invoices.printTemplate.weddingDate': 'Wedding Date',
  'invoices.printTemplate.description': 'Description',
  'invoices.printTemplate.quantity': 'Qty',
  'invoices.printTemplate.unitPrice': 'Unit Price EUR',
  'invoices.printTemplate.lineTotal': 'Line Total EUR',
  'invoices.printTemplate.discountPercent': 'Discount {percent}%',
  'invoices.printTemplate.discount': 'Discount',
  'invoices.printTemplate.subtotal': 'Subtotal',
  'invoices.printTemplate.tailoring': 'Tailoring / Alterations',
  'invoices.printTemplate.grandTotal': 'Grand Total',
  'invoices.printTemplate.depositPaid': 'Deposit Paid',
  'invoices.printTemplate.amountDue': 'Amount Due',
  'invoices.printTemplate.paymentSummary': 'Payment Summary',
  'invoices.printTemplate.legalNotice': 'Current account checks are not accepted. Payments must be made according to agreed terms. Amounts shown include applicable VAT at the time of invoicing.',
  'invoices.printTemplate.acceptanceLabel': 'Accepted by',
  'invoices.printTemplate.customerSignature': 'Customer Signature',
  'invoices.printTemplate.companyLabel': 'For the Company',
  'invoices.printTemplate.stampAndSignature': 'Stamp and Signature',

  // Payments
  'payments.title': 'Payments',
  'payments.addPayment': 'Add Payment',
  'payments.amount': 'Amount',
  'payments.method': 'Payment Method',
  'payments.date': 'Payment Date',
  'payments.notes': 'Notes',
  'payments.printReceipt': 'Print Receipt',
  'payments.downloadReceipt': 'Download Receipt',
  'payments.receiptNumber': 'Receipt #',
  'payments.paymentHistory': 'Payment History',
  'payments.customer.subtitle': 'View your payment history and download receipts.',
  'payments.customer.forInvoice': 'For Invoice {invoice}',
  'payments.customer.paymentMade': 'Payment Made',
  'payments.customer.recordCreated': 'Record Created',
  'payments.customer.loadError': 'Failed to load payment history',
  'payments.customer.downloadError': 'Failed to download receipt',
  'payments.noPayments': 'No Payments Found',
  'payments.noPaymentsDescription': "You haven't made any payments yet. Your payment history will appear here once you make your first payment.",
  'payments.remaining': 'Remaining',
  'payments.total': 'Total',
  'payments.paid': 'Paid',
  'payments.outstanding': 'Outstanding',
  'payments.fullAmount': 'Full Amount',
  'payments.halfAmount': 'Half',
  'payments.refund': 'Refund',
  'payments.maximumAmount': 'Maximum: €{amount}',
  'payments.useNegativeForRefunds': 'Use negative for refunds',
  'payments.amountExceedsBalance': 'Amount exceeds outstanding balance',
  'payments.selectPaymentMethod': 'Select payment method',
  'payments.addNote': 'Add any notes about this payment...',
  'payments.method.cash': 'Cash',
  'payments.method.card': 'Card',
  'payments.method.creditCard': 'Credit Card',
  'payments.method.bankTransfer': 'Bank Transfer',
  'payments.method.bank': 'Bank Transfer',
  'payments.method.other': 'Other',
  'payments.dialog.recordingForRequest': 'Recording payment for payment request',
  'payments.dialog.amountLine': 'Amount: EUR {amount}',
  'payments.dialog.recordForInvoice': 'Record a payment for this invoice (Outstanding: EUR {amount})',
  'payments.dialog.paymentAmount': 'Payment Amount',
  'payments.dialog.amountPlaceholder': '0.00',
  'payments.dialog.requestAmountWithRefund': 'Request Amount: EUR {amount} | Use negative for refunds',
  'payments.dialog.outstandingWithRefund': 'Outstanding: EUR {amount} | Use negative for refunds',
  'payments.dialog.amountExceedsRequest': 'Amount exceeds request amount',
  'payments.dialog.fullRequest': 'Full Request',
  'payments.dialog.fullOutstanding': 'Full Outstanding',
  'payments.dialog.refundFixed': 'Refund EUR {amount}',
  'payments.dialog.noteOptional': 'Note (Optional)',
  'payments.dialog.cancel': 'Cancel',
  'payments.dialog.recording': 'Recording...',

  // Payment receipts
  'receipt.title': 'Payment Receipt',
  'receipt.number': 'Receipt Number',
  'receipt.paymentFor': 'Payment for Invoice',
  'receipt.paymentAmount': 'Payment Amount',
  'receipt.paymentMethod': 'Payment Method',
  'receipt.paymentDate': 'Payment Date',
  'receipt.invoiceTotal': 'Invoice Total',
  'receipt.amountPaid': 'Amount Paid',
  'receipt.remainingBalance': 'Remaining Balance',
  'receipt.thankYou': 'Thank you for your payment',

  // Invoice payments tab
  'invoice.payments.title': 'Payments',
  'invoice.payments.summary': 'Payment Summary',
  'invoice.payments.totalInvoiced': 'Total Invoiced',
  'invoice.payments.totalPaid': 'Total Paid',
  'invoice.payments.totalOutstanding': 'Total Outstanding',
  'invoice.payments.remainingToInvoice': 'Remaining to Invoice',
  'invoice.payments.addPayment': 'Add Payment',
  'invoice.payments.noPayments': 'No payments recorded',
  'invoice.payments.paymentProgress': 'Payment Progress',

  // Invoices page toasts
  'invoices.toast.fetchError': 'Failed to fetch invoices',
  'invoices.toast.printWarning': 'Invoice printed but status update failed',
  'invoices.toast.printed': 'Invoice Printed',
  'invoices.toast.printedDraftDescription': 'Invoice printed and status changed to Issued',
  'invoices.toast.printedDescription': 'Invoice opened in new window. Use your browser\'s print function to save as PDF.',
  'invoices.toast.openError': 'Failed to open invoice',
  'invoices.toast.comingSoon': 'Coming Soon',
  'invoices.toast.pdfComingSoon': 'PDF download functionality will be available soon.',
  'invoices.toast.archived': 'Invoice archived successfully',
  'invoices.toast.archiveError': 'Failed to archive invoice',
  'invoices.toast.deleteTitle': 'Delete Invoice',
  'invoices.toast.deleteConfirm': 'Are you sure you want to delete this invoice?',
  'invoices.toast.deleteWarning': 'The invoice will be deleted and can only be restored by contacting support.',
  'invoices.toast.deleteButton': 'Delete Invoice',
  'invoices.toast.cancel': 'Cancel',
  'invoices.toast.printInvoiceTitle': 'Print Invoice',
  'invoices.invoiceDetails': 'Invoice Details',

  // InvoiceDetailDialog toasts
  'invoices.detail.updated': 'Invoice updated successfully',
  'invoices.detail.updateError': 'Failed to update invoice',
  'invoices.detail.paymentDeleted': 'Payment deleted successfully',
  'invoices.detail.paymentDeleteError': 'Failed to delete payment',
  'invoices.detail.deleted': 'Invoice deleted successfully',
  'invoices.detail.deleteError': 'Failed to delete invoice',
  'invoices.detail.orderLabel': 'Order:',
  'invoices.detail.customerInformation': 'Customer Information',
  'invoices.detail.nameLabel': 'Name:',
  'invoices.detail.phoneLabel': 'Phone:',
  'invoices.detail.notesTitle': 'Notes',
  'invoices.detail.dialogTitle': 'Invoice {number}',
  'invoices.detail.orderNumber': 'Order #{orderId}',
  'invoices.detail.notesPlaceholder': 'Internal notes about this invoice...',
  'invoices.detail.outstandingAmount': 'Outstanding: EUR {amount}',
  'invoices.detail.saveChanges': 'Save Changes',

  // Invoices list page
  'invoices.page.title': 'Invoices',
  'invoices.page.subtitle': 'Manage invoices, balances, and payment status.',
  'invoices.page.createInvoice': 'Create Invoice',
  'invoices.page.searchPlaceholder': 'Search invoices, orders, customers...',
  'invoices.page.filters': 'Filters',
  'invoices.page.columns': 'Columns',
  'invoices.page.clearAll': 'Clear all',
  'invoices.page.sort.placeholder': 'Sort by',
  'invoices.page.sort.issueNewest': 'Issue Date: Newest',
  'invoices.page.sort.issueOldest': 'Issue Date: Oldest',
  'invoices.page.sort.dueLatest': 'Due Date: Latest',
  'invoices.page.sort.dueEarliest': 'Due Date: Earliest',
  'invoices.page.sort.amountHighLow': 'Amount: High to Low',
  'invoices.page.sort.amountLowHigh': 'Amount: Low to High',
  'invoices.page.sort.outstandingHighLow': 'Outstanding: High to Low',
  'invoices.page.sort.outstandingLowHigh': 'Outstanding: Low to High',
  'invoices.page.sort.statusAz': 'Status: A-Z',
  'invoices.page.filter.status': 'Status',
  'invoices.page.filter.issueDate': 'Issue Date',
  'invoices.page.filter.dueDate': 'Due Date',
  'invoices.page.filter.invoiceTotal': 'Invoice Total',
  'invoices.page.filter.outstandingBalance': 'Outstanding Balance',
  'invoices.page.filter.overdueOnly': 'Overdue only',
  'invoices.page.filter.minCurrency': 'Min EUR',
  'invoices.page.filter.maxCurrency': 'Max EUR',
  'invoices.page.filter.clear': 'Clear',
  'invoices.page.pagination.showing': 'Showing {from}-{to} of {total}',
  'invoices.page.pagination.perPage': '{count} / page',
  'invoices.page.pagination.pageOf': 'Page {page} / {total}',

  // Invoices table
  'invoices.table.column.invoiceNumber': 'Invoice #',
  'invoices.table.column.orderNumber': 'Order #',
  'invoices.table.column.customer': 'Customer',
  'invoices.table.column.issueDate': 'Issue Date',
  'invoices.table.column.dueDate': 'Due Date',
  'invoices.table.column.total': 'Total',
  'invoices.table.column.outstanding': 'Outstanding',
  'invoices.table.column.status': 'Status',
  'invoices.table.action.printHtml': 'HTML (Print)',
  'invoices.table.action.printPdfSoon': 'PDF (Coming Soon)',
  'invoices.status.draft': 'Draft',
  'invoices.status.issued': 'Issued',
  'invoices.status.partPaid': 'Part-paid',
  'invoices.status.paid': 'Paid',

  // Payment Requests page
  'paymentRequests.page.title': 'Payment Requests',
  'paymentRequests.page.subtitle': 'Track sent requests, due dates, and outstanding amounts.',
  'paymentRequests.page.searchPlaceholder': 'Search by request, invoice, order or note',
  'paymentRequests.page.filters': 'Filters',
  'paymentRequests.page.columns': 'Columns',
  'paymentRequests.page.clearAll': 'Clear all',
  'paymentRequests.page.sort.placeholder': 'Sort by',
  'paymentRequests.page.sort.createdNewest': 'Created: Newest',
  'paymentRequests.page.sort.createdOldest': 'Created: Oldest',
  'paymentRequests.page.sort.dueLatest': 'Due Date: Latest',
  'paymentRequests.page.sort.dueEarliest': 'Due Date: Earliest',
  'paymentRequests.page.sort.amountHighLow': 'Amount: High to Low',
  'paymentRequests.page.sort.amountLowHigh': 'Amount: Low to High',
  'paymentRequests.page.sort.statusAz': 'Status: A-Z',
  'paymentRequests.page.column.request': 'Request',
  'paymentRequests.page.column.invoice': 'Invoice',
  'paymentRequests.page.column.order': 'Order',
  'paymentRequests.page.column.customer': 'Customer',
  'paymentRequests.page.column.amount': 'Amount',
  'paymentRequests.page.column.dueDate': 'Due Date',
  'paymentRequests.page.column.status': 'Status',
  'paymentRequests.page.column.created': 'Created',
  'paymentRequests.page.filter.status': 'Status',
  'paymentRequests.page.filter.createdDate': 'Created Date',
  'paymentRequests.page.filter.dueDate': 'Due Date',
  'paymentRequests.page.filter.amount': 'Amount',
  'paymentRequests.page.filter.minAmount': 'Min EUR',
  'paymentRequests.page.filter.maxAmount': 'Max EUR',
  'paymentRequests.page.filter.clear': 'Clear',
  'paymentRequests.page.loading': 'Loading payment requests...',
  'paymentRequests.page.empty': 'No payment requests found for current filters.',
  'paymentRequests.page.pagination.showing': 'Showing {from}-{to} of {total}',
  'paymentRequests.page.pagination.perPage': '{count} / page',
  'paymentRequests.page.pagination.pageOf': 'Page {page} / {total}',
  'paymentRequests.status.pending': 'Pending',
  'paymentRequests.status.sent': 'Sent',
  'paymentRequests.status.paid': 'Paid',
  'paymentRequests.status.overdue': 'Overdue',

  // Payments page
  'payments.page.title': 'Payments',
  'payments.page.subtitle': 'Monitor payment history, methods, and settlement status.',
  'payments.page.searchPlaceholder': 'Search by receipt, method, or note',
  'payments.page.filters': 'Filters',
  'payments.page.columns': 'Columns',
  'payments.page.clearAll': 'Clear all',
  'payments.page.sort.placeholder': 'Sort by',
  'payments.page.sort.paymentDateNewest': 'Payment Date: Newest',
  'payments.page.sort.paymentDateOldest': 'Payment Date: Oldest',
  'payments.page.sort.createdNewest': 'Created: Newest',
  'payments.page.sort.createdOldest': 'Created: Oldest',
  'payments.page.sort.amountHighLow': 'Amount: High to Low',
  'payments.page.sort.amountLowHigh': 'Amount: Low to High',
  'payments.page.sort.receiptHighLow': 'Receipt: High to Low',
  'payments.page.sort.receiptLowHigh': 'Receipt: Low to High',
  'payments.page.column.receipt': 'Receipt',
  'payments.page.column.invoice': 'Invoice',
  'payments.page.column.amount': 'Amount',
  'payments.page.column.method': 'Method',
  'payments.page.column.paymentDate': 'Payment Date',
  'payments.page.column.status': 'Status',
  'payments.page.column.request': 'Request',
  'payments.page.column.created': 'Created',
  'payments.page.filter.status': 'Status',
  'payments.page.filter.method': 'Method',
  'payments.page.filter.paymentDate': 'Payment Date',
  'payments.page.filter.createdDate': 'Created Date',
  'payments.page.filter.amount': 'Amount',
  'payments.page.filter.receiptNumber': 'Receipt Number',
  'payments.page.filter.requestLink': 'Payment Request Link',
  'payments.page.filter.minAmount': 'Min EUR',
  'payments.page.filter.maxAmount': 'Max EUR',
  'payments.page.filter.clear': 'Clear',
  'payments.page.requestLink.withRequest': 'With request',
  'payments.page.requestLink.withoutRequest': 'Without request',
  'payments.page.loading': 'Loading payments...',
  'payments.page.empty': 'No payments found for current filters.',
  'payments.page.pagination.showing': 'Showing {from}-{to} of {total}',
  'payments.page.pagination.perPage': '{count} / page',
  'payments.page.pagination.pageOf': 'Page {page} / {total}',
  'payments.status.completed': 'Completed',
  'payments.status.paid': 'Paid',
  'payments.status.pending': 'Pending',
  'payments.status.failed': 'Failed',
  'payments.status.refunded': 'Refunded',
};
